import Validator from "validatorjs"

const useFormUtils = () => {
  const isError = (val, isTouched) => isTouched && (!val || val.length === 0)

  const getErrorMessage = (val, isTouched, message) => isError(val, isTouched) && message

  const isValid = (...vals) => vals.every((val) => val != null && `${val}`.length > 0)

  const validate = {
    numeric: (value) => new Validator({ value }, { value: "numeric" }).passes(),
    required: (value) => new Validator({ value }, { value: "required" }).passes(),
    requiredNumeric: (value) => new Validator({ value }, { value: "required|numeric" }).passes(),
    requiredEmail: (value) => new Validator({ value }, { value: "required|email" }).passes(),
  }

  const touched = (val, set) => {
    if (val == null) {
      set("")
    }
  }

  const debounceTouched = (set) => setTimeout(() => set(true))

  return {
    getErrorMessage,

    isError,
    isValid,

    validate,

    touched,
    debounceTouched,
  }
}

export { useFormUtils }
